module.exports = function getResource(label, vars = []) {
    let resources = {
        freeShipping: 'Vous pouvez maintenant bénéficier de la livraison gratuite!',
        rougeFreeShipping: 'Votre statut de membre Rouge vous donne droit à la LIVRAISON FLASH GRATUITE pour chaque commande.',
        rowFreeShipping: 'Livraison gratuite dans le reste du monde',
        freeFlashShipping: 'Profitez DE LA LIVRAISON FLASH GRATUITE pour chaque commande',
        alreadySubscribedToFlash: 'Vous êtes déjà abonné à Flash. Cet article sera retiré de votre panier.',
        rougeEnrolledForFree: 'Membre Rouge, visitez la page Flash pour vous inscrire GRATUITEMENT. Cet article sera retiré de votre panier.'
    };

    return resources[label];
};
